<template>
  <div>
    <div id="contain">
      <div id="box">
        <img :src="require('../../assets/download_logo.png')" />
      </div>
      <div id="btn">
        <button @click="judgeWechat">
          <img :src="require('../../assets/logo-android.png')" alt="" /><span
            >Android下载</span
          >
        </button>
        <button @click="toAppStore">
          <img
            :src="require('../../assets/logo-apple-filled.png')"
            alt=""
          /><span>App Store下载</span>
        </button>
      </div>
      <div class="page-back" v-if="type" @click="type = !type">
        <img :src="require('../../assets/arrow.png')" class="arrow" />
        <div>点击右上角</div>
        <div>选择在浏览器中打开</div>
      </div>
    </div>
  </div>
</template>

<script>
import { isWechat } from "@/util/wechat.js";
import { getAppUrl } from "@/util/tools.js";

export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      type: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 下载
    downLoadApp() {
      getAppUrl().then((res) => {
        window.open(res.data.data.url);
      });
    },
    // 判断是否为微信浏览器
    judgeWechat() {
      this.type = isWechat();
      if (!this.type) {
        this.downLoadApp();
      }
    },
    toAppStore() {
      this.type = isWechat();
      if (!this.type) {
        window.open("https://itunes.apple.com/cn/app/6443581536");
      }
    },
  },
};
</script>

<style scoped>
.page-back {
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  text-align: center;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  padding-top: 15rem;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  z-index: 100;
}
.arrow {
  position: absolute;
  width: 4rem;
  top: 11rem;
  right: 1rem;
}

#contain {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  transition: 0.5s ease;
  position: relative;
}
#box {
  display: flex;
  justify-content: center;
  padding-bottom: 100px;
}
#box > img {
  width: 50vw;
}
#btn {
  display: flex;
  justify-content: center;
}
#btn button {
  outline: none;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  display: flex;
  font-size: 24px;
  justify-content: center;
  align-items: center;
  padding: 20px 20px;
  background-image: linear-gradient(#facc6e, #f87b2b);
}
#btn > button:nth-child(1) {
  margin-right: 5px;
}
#btn > button:nth-child(2) {
  margin-left: 5px;
}
button > img {
  width: 42px;
}
</style>
